import { DocumentRepository } from "../repositories/DocumentRepository";
import { UploadResultEntity } from "../entities/Document";

/**
 * Upload Statement Use Case
 * Handles bank/credit card statement upload with validation
 */
export class UploadStatementUseCase {
  constructor(private repository: DocumentRepository) {}

  async execute(
    file: File,
    source: "bank" | "credit",
    bankName: string,
    zohoBankAccountId: string
  ): Promise<UploadResultEntity> {
    // Validate file
    if (!file) {
      throw new Error("No file selected");
    }

    // Validate file type (only PDF allowed for statements)
    if (!file.type.includes("pdf")) {
      throw new Error("Only PDF files are allowed for statement uploads");
    }

    // Validate bank information
    if (!bankName) {
      throw new Error("Bank name is required");
    }

    if (!zohoBankAccountId) {
      throw new Error("Bank account ID is required");
    }

    // Upload through repository
    return await this.repository.uploadStatement(
      file,
      source,
      bankName,
      zohoBankAccountId
    );
  }
}
